export default __webpack_public_path__ + "7f2f23e6511f42d313d841c6529278bf.pdf";